"use client";

import clsx from "clsx";
import React from "react";

const RequiredBadge = ({ isActive = true }: { isActive?: boolean }) => {
  return (
    <span
      className={clsx(
        "h-fit flex-shrink-0 px-1 py-0.5 text-center text-xxs text-white",
        isActive ? "bg-attention" : "bg-button-disabled"
      )}
    >
      {isActive ? "必須" : "任意"}
    </span>
  );
};

export default RequiredBadge;
